import './App.css';
import Routing from './routes/routes';

function App() {
  return <Routing />;
}

export default App;
